import PropTypes from 'prop-types';
import { Button, DateInput } from 'ypf-pas-general-ui-components';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';

const DateRange = ({
  finalDate,
  handleAddRange,
  handleSuprRange,
  id,
  index,
  max,
  min,
  onChangeFinalDate,
  onChangeStartDate,
  startDate,
  disableSuprButton,
  disableAddButton
}) => (
  <div className="d-flex justify-content-between">
    <div>
      <DateInput
        max={max}
        min={min}
        name="startDate"
        onChange={(evt) => onChangeStartDate(evt.target.value, index)}
        placeholder="Desde"
        value={startDate}
        widthDateInput="100%"
      />
    </div>
    <div className="mx-1">
      <DateInput
        max={max}
        min={startDate}
        name="finalDate"
        onChange={(evt) => onChangeFinalDate(evt.target.value, index)}
        placeholder="Hasta"
        value={finalDate}
        widthDateInput="100%"
      />
    </div>
    <div className="mx-1">
      <Button
        colorIcon="primary"
        disabled={disableAddButton}
        icon={AiOutlinePlusCircle}
        onClick={() => handleAddRange(id)}
        sizeIcon="24px"
        type="button"
        variant="light-gray"
        widthButton="40px"
      />
    </div>
    <div>
      <Button
        colorIcon="danger"
        disabled={disableSuprButton}
        icon={AiOutlineMinusCircle}
        onClick={() => handleSuprRange(index)}
        sizeIcon="24px"
        type="button"
        variant="light-gray"
        widthButton="40px"
      />
    </div>
  </div>
);

DateRange.propTypes = {
  finalDate: PropTypes.string.isRequired,
  handleAddRange: PropTypes.func.isRequired,
  handleSuprRange: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  max: PropTypes.string.isRequired,
  min: PropTypes.string.isRequired,
  onChangeFinalDate: PropTypes.func.isRequired,
  onChangeStartDate: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  disableSuprButton: PropTypes.bool.isRequired,
  disableAddButton: PropTypes.bool.isRequired
};

export default DateRange;
